/***
 * 积木报表打印
 */
import { post, getDomain } from '../../../utils/index'
import { pgMessage } from '../../message/index'

export async function jmreport(data, param) {
  if (!data || data?.length <= 0) {
    pgMessage('暂无需要打印的数据！')
    Promise.reject()
  }

  for (let index = 0; index < data.length; index++) {
    let result = await sendPrint(data[index], param)
    if (result) {
      console.info(`${index + 1}:${Date.now()}: 请求成功！`)
    } else {
      console.info(`${index + 1}:${Date.now()}: 请求失败！`)
    }
  }
}

function sendPrint(im, param, second) {
  return new Promise(async (resolve) => {
    const protocol = second ?? window.location.protocol
    const [, error] = await post(
      `${protocol}//localhost:${protocol === 'http:' ? '7100' : '7101'}/api/jimu/print`,
      {
        ...param,
        Url: getDomain('/jimu/jmreport/exportPdfStream'),
        Body: im,
      },
      { errorTip: null }
    )

    if (error) {
      if (second) {
        pgMessage.error(
          error?.msg?.config && !error?.msg?.response
            ? '打印接口无响应，请检查打印服务是否启动'
            : error?.msg
        )
        resolve(false)
      } else sendPrint(im, param, window.location.protocol == 'https:' ? 'http:' : 'https:')
    } else resolve(true)
  })
}
